import { createAction, props } from '@ngrx/store';
import { Team } from '@app/shared/models/team';

export const LoadGuests = createAction(
  '[Guests] Load Guests'
);

export const LoadGuestsSuccess = createAction(
  '[Guests] Load Guests Success',
  props<{ emails: any[] }>()
);

export const LoadGuestsFailure = createAction(
  '[Guests] Load Guests Failure',
  props<{ error: string }>()
);

export const AddEmail = createAction(
  '[Guests] Add Email',
  props<{ team: string, email: string }>()
);

export const AddEmailFailure = createAction(
  '[Guests] Add Email Failure',
  props<{ error: string }>()
);

export const DeleteEmail = createAction(
  '[Guests] Delete Email',
  props<{ team: string, email: string }>()
);

export const AddEmailPattern = createAction(
  '[Guests] Add Email Pattern',
  props<{ team: string, pattern: string }>()
);

export const AddEmailPatternFailure = createAction(
  '[Guests] Add Email Pattern Failure',
  props<{ error: string }>()
);

export const DeleteEmailPattern = createAction(
  '[Guests] Delete Email Pattern',
  props<{ team: string, pattern: string }>()
);

export const UpdateTeamConfig = createAction(
  '[Guests] Update Team Config',
  props<{ team: string, config: any }>()
);

export const UpdateTeamConfigSuccess = createAction(
  '[Guests] Update Team Config Success',
  props<{ team: any }>()
);

export const UpdateTeamConfigFailure = createAction(
  '[Guests] Update Team Config Failure',
  props<{ error: string }>()
);

export const ResetError = createAction(
  '[Guests] Reset Error'
);

export const LoadGuestDetails = createAction(
  '[Guests] Load Guests Details',
  props<{ guest: any }>()
);

export const LoadGuestDetailsSuccess = createAction(
  '[Guests] Load Guests Details Success',
  props<{ guest: any }>()
);

export const LoadGuestDetailsFailure = createAction(
  '[Guests] Load Guests Details Failure',
  props<{ error: string }>()
);

export const UpdateGuestDetails = createAction(
  '[Guests] Update Guests Details',
  props<{ guest: any }>()
);

export const UpdateGuestDetailsSuccess = createAction(
  '[Guests] Update Guests Details Success',
  props<{ guest: any }>()
);

export const UpdateGuestDetailsFailure = createAction(
  '[Guests] Update Guests Details Failure',
  props<{ error: string }>()
);

export const AttachGuestToTeam = createAction(
  '[Guests] Attach Guest To Team',
  props<{ guest: any, team: string }>()
);

export const AttachGuestToTeamSuccess = createAction(
  '[Guests] Attach Guest To Team Success',
  props<{ team: Team }>()
);

export const AttachGuestToTeamFailure = createAction(
  '[Guests] Attach Guest To Team Failure',
  props<{ error: any }>()
);

export const DetachGuestFromTeam = createAction(
  '[Guests] Detach Guest From Team',
  props<{ guest: any, team: string }>()
);

export const DetachGuestFromTeamSuccess = createAction(
  '[Guests] Detach Guest From Team Success',
  props<{ team: Team }>()
);

export const DetachGuestFromTeamFailure = createAction(
  '[Guests] Detach Guest From Team Failure',
  props<{ error: string }>()
);

export const DeleteGuest = createAction(
  '[Guests] Delete Guest',
  props<{ email: any }>()
);

export const DeleteGuestSuccess = createAction(
  '[Guests] Delete Guest Success'
);

export const DeleteGuestFailure = createAction(
  '[Guests] Delete Guest Failure',
  props<{ error: string }>()
);